var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "17px",
    viewBox: "0 0 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/insta Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.720540365
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_Metrics_Acc-Performance_1",
    transform: "translate(-297.000000, -492.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(282.000000, 477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/youtube",
    transform: "translate(15.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5056152,2.62939453 C23.2289429,1.60125731 22.4183349,0.790832531 21.3903809,0.513977062 C19.5122681,0 11.9998169,0 11.9998169,0 C11.9998169,0 4.48754883,0 2.60943605,0.494384766 C1.60125731,0.771057141 0.770874,1.60144041 0.494201672,2.62939453 C0,4.50732422 0,8.40197756 0,8.40197756 C0,8.40197756 0,12.3162232 0.494201672,14.1745605 C0.771057141,15.2025146 1.58148192,16.0131225 2.60961914,16.289978 C4.50732422,16.8039551 12,16.8039551 12,16.8039551 C12,16.8039551 19.5122681,16.8039551 21.3903809,16.3095703 C22.4185181,16.0328979 23.2289429,15.2222901 23.5057983,14.1943359 C24.0001009,12.3162232 24.0001009,8.42175291 24.0001009,8.42175291 C24.0001009,8.42175291 24.0197754,4.50732422 23.5056152,2.62939453 Z",
    id: "Path",
    fill: "#FF0000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "9.60791016 12 15.8549194 8.40197756 9.60791016 4.80395508"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.088d9d8a73f7813d6bc437746fea381a.svg";
export { ForwardRef as ReactComponent };